export const drinks =[
    { key: 'Gaseosa Pool 250ml',
      value: 1100,
      text: 'Gaseosa Pool 250ml', 

      imgDrink: require('../img/imgBebidas/pool.jpg'),
    },
    { key: 'Gaseosa Pool 400ml',
      value: 1500,
      text: 'Gaseosa Pool 400ml' ,
      imgDrink: require('../img/imgBebidas/pool400.jpg'),
    },
    // { key: 'Coca-Cola 400ml',
    //   value: 3500,
    //   text: 'Coca-Cola 400ml' ,
    //   imgDrink: require('../img/imgBebidas/cocacola400ml.jpg'),
    // },
    // { key: 'Cocacola sin azucar 400ml',
    //   value: 3500,
    //   text: 'Cocacola sin azucar 400ml' ,
    //   imgDrink: require('../img/imgBebidas/cocacolaSinAzucar400ml.jpg'),
    // },
    ]
